function cartAddUrl() {
  const root = window.Shopify?.routes?.root || '/';
  return `${root}cart/add.js`;
}

function checkoutUrl() {
  const root = window.Shopify?.routes?.root || '/';
  return `${root}checkout`;
}

function bindBuyNowButtons(scope = document) {
  scope.querySelectorAll('[data-aph-buy-now]').forEach((button) => {
    if (button.dataset.aphBound === 'true') return;
    button.dataset.aphBound = 'true';

    button.addEventListener('click', async () => {
      if (button.disabled) return;

      const productForm = button.closest('product-form-component');
      const form = productForm?.querySelector('form');
      const variantInput = form?.querySelector('[name="id"]');
      if (!variantInput?.value) return;

      const quantityInput = form?.querySelector('[name="quantity"]');
      const quantity = quantityInput?.value
        ? Number(quantityInput.value)
        : Number(productForm?.dataset.quantityDefault) || 1;

      button.disabled = true;
      const label = button.textContent?.trim() || 'Αγόρασε τώρα';

      try {
        const response = await fetch(cartAddUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: Number(variantInput.value), quantity }],
          }),
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }

        window.location.href = checkoutUrl();
      } catch (error) {
        console.error('[aph-buy-now]', error);
        button.disabled = false;
        button.textContent = label;
        window.alert('Δεν ήταν δυνατή η ολοκλήρωση της αγοράς. Δοκιμάστε ξανά.');
      }
    });
  });
}

bindBuyNowButtons();
document.addEventListener('DOMContentLoaded', () => bindBuyNowButtons());
document.addEventListener('shopify:section:load', (event) => {
  bindBuyNowButtons(event.target);
});
